<template>
	<contentBox v-if="!loadError" v-bind:loading="loading">
		<contentTitle label="COLLECTION" close="routeClose">
			<h2 class="text-white font-weight-light pb-2">Unlocked Parcels</h2>
		</contentTitle>
		<contentBody v-bind:locked="token === null" bg="#f8f9fa">
			<div v-if="!unlocked || unlocked.length < 1" class="m-3">
				<div v-if="planCurrentIsDayPass || planCurrentIsStudio">
					<h4>All parcels are unlocked</h4>
					<p>You have purchased a plan which unlocks all parcels on Scoutred</p>
				</div>
				<div v-else>
					<h4>No unlocked parcels</h4>
					<p>Purchase a plan to unlock all parcels or unlock parcels individually to add them to this list</p>
				</div>
			</div>
			<ul v-else class="list-group list-group-flush">
				<li 
					v-on:click="routeParcel(parcel)"
					v-on:mouseenter="mouseenter($event,parcel)" 
					v-on:mouseleave="mouseleave($event,parcel)" 
					v-for="(parcel, index) in unlocked" 
					:key="parcel.id" 
					class="list-group-item list-group-item-action justify-content-between d-flex align-items-center cursor-pointer">
					
					<span>{{parcelTitle(parcel)}} <small class="text-secondary">{{parcelSub(parcel)}}</small></span> 
				</li>
			</ul>

		</contentBody>
	</contentBox>
</template>

<script>

import contentBox from '../content';
import contentActions from '../content/content-actions';
import contentBody from '../content/content-body';
import contentTitle from '../content/content-title';

export default {
	name: 'collectionUnlocked',

	components:{
		contentBox,
		contentActions,
		contentBody,
		contentTitle,
	},

	computed: {
		mapLoaded: function(){
			return this.$store.state.map.loaded;
		},
		planCurrent:function(){
			return this.$store.state.plan.current;
		},
		planCurrentIsDayPass:function(){
			if (!this.planCurrent) return false;
			return (!this.planCurrent.plan.recurring && this.planCurrent.plan.interval === 'day')? true: false;
		},
		planCurrentIsStudio:function(){
			if (!this.planCurrent) return false;
			return (this.planCurrent.plan.recurring)? true: false;
		},
		unlocked: function(){
			return this.$store.state.collections.unlocked;
		},
		unlockedFeatures: function(){
			return this.$store.state.collections.unlockedFeatures;
		},
		token: function(){
			return this.$store.state.agent.token;
		},
	},
	data: function(){
		return {
			loading: true,
			loadError: null,
			parcelPoi: null
		}
	},
	destroyed: function(){
		this.$store.dispatch('MAP_POI_SET', null);
		this.$store.dispatch('MAP_POI_HOVER_SET', null);
	},
	methods: {
		checkReady:function(){
			if (this.mapLoaded && !this.loading) return this.poiSet();
		},
		get:async function(){
			this.loadError = null;
			try {
				await this.$store.dispatch('COLLECTIONS_UNLOCKED_GET');
				await this.$store.dispatch('COLLECTIONS_UNLOCKED_FEATURES_GET');
				this.loading = false;
				this.checkReady();
			} catch(e){
				console.log('loadError:',e.toString());
				this.loadError = e;		
			}
		},
		
		mouseenter: function(e, parcel){

			if (this.parcelPoi && this.parcelPoi[parcel.id]){
				const feature = {
					id:parcel.id,
					source:'poi'
				};
				this.$store.dispatch('MAP_FEATURE_HOVER_SET', [feature]);
			}
			
		},

		mouseleave: function(e, permit){
			this.$store.dispatch('MAP_FEATURE_HOVER_SET',null);	
		},
		
		parcelTitle:function(parcel){
			let str = '';
			if (parcel.address && parcel.address.street && parcel.address.street.name){
				if (parcel.address.street.number !== null) str += parcel.address.street.number+' ';
				if (parcel.address.street.name !== null) str += parcel.address.street.name+' ';
				if (parcel.address.street.suffix !== null) str += parcel.address.street.suffix;
				if (parcel.address.unit !== null) str += ' #'+parcel.address.unit;
			} else {
				str = parcel.apnFmt;
			}
			return str;
		},
		parcelSub:function(parcel){
			let str = '';
			if (parcel.address){
				if (parcel.address.jurisdiction !== null) str += parcel.address.jurisdiction+', ';
				if (parcel.address.state !== null) str += parcel.address.state+' ';
				if (parcel.address.postal !== null) str += parcel.address.postal;
			}
			return str;
		},
		poiSet:function(){
			let poi = [];
			if (!this.unlockedFeatures || this.unlockedFeatures.features.length < 1) return;

			this.parcelPoi = {};
			var bounds = new mapboxgl.LngLatBounds();
			
			this.unlockedFeatures.features.map((feature)=>{
				//	build our geojson for the point and add it to our features array
				const feat = {
					...feature,
					properties:{
						...feature.properties,
						route:{
							name: 'parcels', 
							params:{
								id:feature.id
							}
						}
					}
				};
				bounds.extend(feature.geometry.coordinates);
				this.parcelPoi[feature.id] = feat;
				poi.push(feat);
			});

			this.$store.dispatch('MAP_FIT_BOUNDS', {bounds:{bbox:bounds.toArray()}});
			this.$store.dispatch('MAP_POI_SET', poi);				
		},
		routeClose:function(){
			this.$router.push({
				name: 'home', 
				params:{}
			});
		},
		routeParcel:function(parcel){
			this.$router.push({
				name: 'parcels', 
				params:{
					id:parcel.id
				}
			});
		},
	},
	mounted:function(){
		this.get();
	},
	watch:{
		mapLoaded:function(){
			this.checkReady();
		},
		unlockedFeatures:function(){
			this.checkReady();
		},
	}
}

</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/collection/collection-unlocked.vue